import React from 'react';
import classNames from 'classnames/bind';
import styles from './Provide.module.scss';

const cx = classNames.bind(styles);

function Provide_01() {
	return (
		<div className={cx('terms')}>
			<dl className={cx('dl_type1', 'mt0')}>
				<dt>제공 받은 자</dt>
				<dd>보증수리 제휴 정비소</dd>
				<dt>이용목적</dt>
				<dd>엔카보증 가입자의 본인 확인 및 보증수리 서비스 제공</dd>
				<dt>제공하는 항목</dt>
				<dd>(필수) 이름, 생년월일, 휴대전화번호, 주소, 차량번호, 이메일 </dd>
				<dt>보유 및 이용 기간</dt>
				<dd>보증수리 신청일로부터 1년</dd>
			</dl>
			<p className={cx('pt20')}>*고객님께서는 위의 항목에 동의를 거부할 권리가 있습니다. 단, 미동의시 서비스 이용이 제한됩니다</p>
		</div>
	);
}

export default Provide_01;
